module.exports = __webpack_public_path__ + "static/_default-973455b44b441f6af7bc4541dd4de03e.jpg";